export enum SVGIcons {
  baseArrow = 'svg__arrow',
  ballLoader = 'svg_ball_loader',
}

export type SVGIconsType = {
  [key in keyof typeof SVGIcons]: string;
};

type SvgIcons = keyof typeof SVGIcons;

export type IconType = (typeof SVGIcons)[SvgIcons];
